import { Injectable, inject, ViewContainerRef, NgZone } from '@angular/core';
import { BrnDialogService } from '@spartan-ng/brain/dialog';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from './confirmation-dialog.component';
import { ConfirmDialogContext, ConfirmDialogOptions } from './confirmation-dialog.interfaces';
import { ViewContainerRefService } from '@app/finxone-web-frontend/app/lib/services/view-container-ref/view-container-ref.service';

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  private readonly _dialogService = inject(BrnDialogService);
  private readonly _rootViewContainerRef = inject(ViewContainerRefService);
  private readonly _zone = inject(NgZone);

  async confirm(
    viewContainerRef: ViewContainerRef | null,
    options: ConfirmDialogOptions = {},
  ): Promise<boolean> {
    return this._zone.run(async () => {
      const vcr = viewContainerRef ?? this._rootViewContainerRef.get();
      const context: ConfirmDialogContext = {
        title: options.title ?? 'Are you sure?',
        content: options.content ?? 'This action cannot be undone.',
        positiveText: options.positiveText ?? 'Confirm',
        negativeText: options.negativeText ?? 'Cancel',
      };

      const dialogRef = this._dialogService.open(ConfirmDialogComponent, vcr, context);

      const result = await firstValueFrom(dialogRef.closed$);

      return result === true;
    });
  }
}
